import React from "react";
import {
  Modal,
  Button,
  Label,
  Typography,
} from "@anchor/react-components/dist/lib/components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import UserInfo from "../../../context/UserAccessContext";
import { IsLocked } from "../../IsLocked/IsLocked";
import "../rcstyles.css";
// import { useWebSocket } from "../../../context/WebSocketContext/WebSocketContext";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const QUILL_FORMATS = [
  "header",
  "bold", "italic", "underline",
  "list", "bullet",
  "link",
];

function RecovModal({
  handleRecovModal,
  recovModal,
  recovery,
  setRecovery,
  onSave,
  savingRef,
  lockedFields,
}) {
  // const { lockField, unlockField } = useWebSocket();
  const lockField = null; // WebSocket disabled
  const unlockField = null; // WebSocket disabled
  const { graphData } = UserInfo();

  const handleFieldLocking = (fieldName) => {
    // lockField(fieldName, graphData.username);
    // WebSocket disabled
  };

  const handleFieldUnlocking = (fieldName) => {
    // unlockField(fieldName, recovery);
    // WebSocket disabled
  };

  return (
    <>
      <Modal
        width="1500"
        height="600"
        backdropcloseactiondisabled={true}
        actions={{
          primaryAction: (
            <Button label="OK" onClick={onSave} appearance="alt" />
          ),
        }}
        heading=<Typography
          variant="h3"
          fontStyle="bold"
          style={{ textAlign: "center", marginTop: "10px" }}
        >
          Recovery
        </Typography>
        onClose={() => {
          handleRecovModal();
        }}
        showCloseIcon={true}
        open={recovModal}
      >
        <div className="">
          <Typography
            variant="h3"
            fontStyle="bold"
            style={{ fontSize: "18px" }}
          >
            Description
          </Typography>

          <Typography paragraph={true} style={{ fontSize: "14px" }}>
            <i>
              <strong>Sample: </strong> by
              determining.....artefacts/knowledge/findings......actions were
              performed....The steps were per SOP/KA. Following
              checks....performed to determine health of the service post
              recovery and full restore by "time/date"
            </i>
          </Typography>
          <ReactQuill
            theme="snow"
            modules={QUILL_MODULES}
            formats={QUILL_FORMATS}
            value={recovery.recovery}
            onChange={(value) => {
              setRecovery(value);
              handleFieldLocking("recovery");
            }}
            style={{ background: "#fff", minHeight: "200px" }}
          />
        </div>
        <IsLocked
          field="recovery"
          lockedFields={lockedFields}
          graphData={graphData}
        />
      </Modal>
    </>
  );
}

export default RecovModal;
